import AccountInformation from './AccountInformation/AccountInformation.vue'
import Payables from './Payables/Payables.vue'
import OrderHistory from './OrderHistory/OrderHistory.vue'
import Header from '../Header/Header.vue'
import Nav from '../Nav/Nav.vue'

export default {
    name: 'Account',
    components: {
        Header,
        AccountInformation,
        Payables,
        OrderHistory,
        Nav
    },
    created() {
        this.$gtag.screenview({
            app_name: 'Retailers',
            screen_name: 'Account',
        })
    }
}